export default function ArticleSection() {
  const featuredArticle = {
    id: 0,
    icon: '⚡',
    badge: '特集',
    title: '【2026年最新】即日発行できるクレジットカードおすすめ5選',
    description: '今日中にカードが欲しい方必見。最短即日発行可能なクレジットカードを厳選してご紹介。審査のポイントから受け取り方法まで、初心者にもわかりやすく解説します。',
    keywords: ['即日発行', '最短当日', 'スピード審査'],
    href: '/articles/instant-issue',
    image: 'https://public.readdy.ai/ai/img_res/8c071758ff8938801a547f185f716c74.jpg',
    readTime: '5分',
  };

  const articles = [
    {
      id: 1,
      icon: '💰',
      badge: '年会費無料',
      title: '年会費無料でおすすめのクレジットカードランキング',
      description: 'コストゼロで持てる高還元カード。年会費無料でも充実した特典が受けられるカードを比較。',
      keywords: ['永年無料', 'コスト0円'],
      href: '/articles/free-annual-fee',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20wallet%20with%20credit%20cards%20on%20soft%20mint%20green%20background%20minimalist%20style%20financial%20savings%20concept%20clean%20professional%20photography&width=400&height=300&seq=article-free-1&orientation=landscape',
      readTime: '4分',
      color: 'from-emerald-500 to-teal-500',
    },
    {
      id: 2,
      icon: '🎯',
      badge: '高還元率',
      title: 'ポイント還元率が高いクレジットカード比較',
      description: '還元率1%以上の高還元カードを徹底比較。ポイントを効率的に貯めたい方におすすめ。',
      keywords: ['還元率1%以上', 'ポイント高還元'],
      href: '/articles/high-return-rate',
      image: 'https://readdy.ai/api/search-image?query=Golden%20coins%20and%20credit%20card%20on%20warm%20amber%20background%20rewards%20points%20concept%20minimalist%20clean%20professional%20financial%20photography&width=400&height=300&seq=article-return-1&orientation=landscape',
      readTime: '6分',
      color: 'from-amber-500 to-orange-500',
    },
    {
      id: 3,
      icon: '🎓',
      badge: '学生OK',
      title: '学生・29歳以下におすすめのクレジットカード5選',
      description: '学生や若年層でも作りやすく、特典が充実したカードを厳選。初めてのカード選びに。',
      keywords: ['学生OK', '若年層向け'],
      href: '/articles/student-cards',
      image: 'https://readdy.ai/api/search-image?query=Young%20person%20hand%20holding%20credit%20card%20with%20soft%20blue%20sky%20background%20student%20lifestyle%20concept%20clean%20minimalist%20professional%20photography&width=400&height=300&seq=article-student-1&orientation=landscape',
      readTime: '5分',
      color: 'from-sky-500 to-cyan-500',
    },
    {
      id: 4,
      icon: '⚖️',
      badge: '徹底比較',
      title: '大手ECモール系カードと三井住友カードを徹底比較',
      description: '人気2大カードを項目別に比較。あなたに合うのはどっち？選び方のポイントを解説。',
      keywords: ['大手ECモール系vs三井住友', 'スペック比較'],
      href: '/articles/rakuten-vs-mitsui',
      image: 'https://readdy.ai/api/search-image?query=Two%20premium%20credit%20cards%20side%20by%20side%20on%20soft%20lavender%20purple%20background%20comparison%20concept%20clean%20minimalist%20professional%20photography&width=400&height=300&seq=article-compare-1&orientation=landscape',
      readTime: '7分',
      color: 'from-violet-500 to-purple-500',
    },
  ];

  return (
    <section className="py-10 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* ヘッダー */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <span className="inline-block bg-gradient-to-r from-teal-100 to-emerald-100 text-teal-700 px-4 sm:px-5 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold mb-3 sm:mb-6 shadow-sm">
            📚 お役立ち記事
          </span>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-5 tracking-tight px-4">
            クレジットカード選びの
            <br className="sm:hidden" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">完全ガイド</span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            目的別・シーン別に最適なカードの選び方を詳しく解説
          </p>
        </div>

        {/* 特集記事（大型カード） */}
        <a
          href={featuredArticle.href}
          className="block mb-6 sm:mb-12 group cursor-pointer"
        >
          <div className="relative bg-white rounded-xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              {/* 画像エリア */}
              <div className="relative h-48 sm:h-64 md:h-80 overflow-hidden">
                <img
                  src={featuredArticle.image}
                  alt={featuredArticle.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <span className="absolute top-3 sm:top-4 left-3 sm:left-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-xs font-bold shadow-lg">
                  ✨ FEATURED
                </span>
              </div>
              
              {/* コンテンツエリア */}
              <div className="p-5 sm:p-8 md:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-4 flex-wrap">
                  <span className="text-xl sm:text-3xl">{featuredArticle.icon}</span>
                  <span className="bg-rose-100 text-rose-600 px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-bold">
                    {featuredArticle.badge}
                  </span>
                  <span className="text-gray-400 text-xs sm:text-sm flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {featuredArticle.readTime}で読める
                  </span>
                </div>
                
                <h3 className="text-lg sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-4 group-hover:text-teal-600 transition-colors leading-tight">
                  {featuredArticle.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed mb-3 sm:mb-6 text-sm sm:text-base">
                  {featuredArticle.description}
                </p>
                
                <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-6">
                  {featuredArticle.keywords.map((keyword, idx) => (
                    <span
                      key={idx}
                      className="bg-gray-100 text-gray-600 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs font-medium"
                    >
                      #{keyword}
                    </span>
                  ))}
                </div>
                
                <div className="flex items-center gap-2 text-teal-600 font-bold group-hover:gap-4 transition-all text-sm sm:text-base">
                  <span>記事を読む</span>
                  <i className="ri-arrow-right-line text-base sm:text-lg"></i>
                </div>
              </div>
            </div>
          </div>
        </a>

        {/* 記事グリッド */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {articles.map((article) => (
            <a
              key={article.id}
              href={article.href}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 h-full flex flex-col hover:-translate-y-2">
                {/* 画像 */}
                <div className="relative h-40 sm:h-44 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <span className={`absolute top-2 sm:top-3 left-2 sm:left-3 bg-gradient-to-r ${article.color} text-white px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-bold shadow-md`}>
                    {article.badge}
                  </span>
                  <span className="absolute bottom-2 sm:bottom-3 right-2 sm:right-3 bg-white/90 backdrop-blur-sm text-gray-700 px-2 py-0.5 sm:py-1 rounded-md text-xs font-medium flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                
                {/* コンテンツ */}
                <div className="p-4 sm:p-5 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 mb-2 sm:mb-3">
                    <span className="text-lg sm:text-xl">{article.icon}</span>
                  </div>
                  
                  <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-teal-600 transition-colors leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                  
                  <p className="text-gray-500 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4 line-clamp-2 flex-1">
                    {article.description}
                  </p>
                  
                  <div className="flex flex-wrap gap-1 sm:gap-1.5 mb-3 sm:mb-4">
                    {article.keywords.map((keyword, idx) => (
                      <span
                        key={idx}
                        className="bg-gray-50 text-gray-500 px-2 py-0.5 sm:py-1 rounded text-xs"
                      >
                        #{keyword}
                      </span>
                    ))}
                  </div>
                  
                  <div className="flex items-center gap-1 sm:gap-1.5 text-teal-600 font-semibold text-xs sm:text-sm group-hover:gap-3 transition-all mt-auto">
                    <span>続きを読む</span>
                    <i className="ri-arrow-right-s-line"></i>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* 追加CTA */}
        <div className="mt-10 sm:mt-16 text-center">
          <div className="relative bg-gradient-to-br from-teal-50 via-white to-emerald-50 rounded-xl sm:rounded-3xl p-6 sm:p-10 max-w-3xl mx-auto border border-teal-100 overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-teal-200/30 to-emerald-200/30 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-emerald-200/30 to-teal-200/30 rounded-full blur-3xl"></div>
            
            <div className="relative">
              <span className="text-3xl sm:text-4xl mb-2 sm:mb-4 block">🤔</span>
              <h3 className="text-lg sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 px-4">
                まだ迷っている方へ
              </h3>
              <p className="text-gray-600 mb-5 sm:mb-8 text-sm sm:text-base px-4">
                あなたにぴったりのクレジットカードを見つけるお手伝いをします
              </p>
              <a
                href="#ranking-section"
                className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 text-white font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base w-full sm:w-auto"
              >
                <i className="ri-trophy-line"></i>
                人気ランキングを見る
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}